const destinations = [
  { flag: "🇩🇪", country: "Germany", city: "Frankfurt / Hamburg", angle: "Eastman Chemical plant visits, BASF partnership meetings, German chemical industry conferences", distance: "Flies via Charlotte (CLT) or Atlanta (ATL)" },
  { flag: "🇳🇱", country: "Netherlands", city: "Amsterdam / Rotterdam", angle: "Eastman chemical trade conferences, European specialty materials meetings, and petrochemical industry summits", distance: "Flies via Washington Dulles (IAD)" },
  { flag: "🇬🇧", country: "United Kingdom", city: "London / Cardiff", angle: "BAE Systems UK headquarters visits, defense contractor meetings, and Wellmont Health medical conferences at London hospitals", distance: "Flies via Charlotte or Dulles" },
  { flag: "🇨🇳", country: "China", city: "Shanghai / Beijing", angle: "Eastman Chemical Asia operations, supplier site visits, and chemical manufacturing partner facilities in eastern China", distance: "Flies via Atlanta (ATL) or Chicago (ORD)" },
  { flag: "🇸🇬", country: "Singapore", city: "Singapore City", angle: "Eastman Asia-Pacific headquarters and regional chemical distribution hub — a top destination for Kingsport corporate executives", distance: "Flies via Atlanta or Chicago" },
  { flag: "🇰🇷", country: "South Korea", city: "Seoul / Busan", angle: "Eastman chemical industry partners, Korean technology company site visits, and specialty materials trade shows", distance: "Flies via Atlanta (ATL)" },
  { flag: "🇲🇽", country: "Mexico", city: "Cancún / Mexico City", angle: "Sullivan County family beach vacations, Eastman Mexico operations visits, and winter escapes from Northeast Tennessee", distance: "Flies via Atlanta (ATL)" },
  { flag: "🇯🇵", country: "Japan", city: "Tokyo / Osaka", angle: "Eastman Chemical Japan partnerships, automotive specialty materials clients, and Kingsport executive international business travel", distance: "Flies via Atlanta (ATL)" },
];

export default function KingsportDestinationsSection() {
  return (
    <section id="destinations" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Popular Destinations</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Kingsport Travelers Are Going
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Eastman Chemical's global footprint sends Kingsport executives to Germany, Netherlands, China, Singapore, and beyond — here's where the corporate world goes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {destinations.map((dest, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-xl p-6 hover:bg-white border border-transparent hover:border-[#F6C344] transition-all group">
              <div className="text-4xl mb-4">{dest.flag}</div>
              <h3 className="font-serif font-bold text-[#1A365D] text-lg mb-1">{dest.country}</h3>
              <p className="text-[#F6C344] font-semibold text-sm mb-3">{dest.city}</p>
              <p className="text-gray-500 text-xs leading-relaxed mb-3">{dest.angle}</p>
              <div className="flex items-center gap-1.5 text-xs text-gray-400">
                <i className="ri-flight-takeoff-line text-[#1A365D]"></i>
                <span>{dest.distance}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#F7F8FA] rounded-xl p-8 text-center">
          <h3 className="font-serif text-2xl font-bold text-[#1A365D] mb-3">Eastman Chemical International HQ — Kingsport</h3>
          <p className="text-gray-500 max-w-2xl mx-auto text-sm leading-relaxed mb-6">
            Eastman Chemical operates globally in 100+ countries. Their Kingsport employees regularly travel to Germany, Netherlands, China, and Singapore. We provide priority corporate processing for the Eastman team and their families.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] text-[#1A365D] font-semibold px-8 py-3 rounded-lg hover:bg-[#e5b33f] transition-all whitespace-nowrap"
          >
            <i className="ri-passport-line"></i>
            Start Your Application
          </a>
        </div>
      </div>
    </section>
  );
}